export default {
  API_ENDPOINT: 'https://immense-coast-07850.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token',
}
